import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import {
  ComposedChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  LineChart,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  PieChart,
  Pie,
  Cell,
  Sector,
  Label,
  LabelList,
} from "recharts";
import { fetchNetworkAnalytics } from "DashboardNetworkingAction";
import { chartWidth, DATE_FORMAT } from "Constants";
import LocaleStrings from "Languages";

class DashboardNetworking extends Component {
  constructor(props) {
    super(props);

    this.state = { hitstype: "date", data: [], innerLoader: props.newprop };
  }

  componentDidMount() {
    setTimeout(() => {
      // this.arrangeDataWeekly(this.props.networkings);
      this.arrangeDataDateWise(this.props.networkings, this.props.dateProps);
    }, 300);
  }

  componentWillReceiveProps(nextprops) {
    if (this.state.innerLoader != nextprops.newprop) {
      this.setState({ innerLoader: !nextprops.newprop });

      this.state.hitstype == "weekly"
        ? this.arrangeDataWeekly(nextprops.networkings)
        : this.state.hitstype == "monthly"
        ? this.arrangeDataMonthly(nextprops.networkings)
        : this.arrangeDataDateWise(nextprops.networkings, nextprops.dateProps);
    }
  }

  arrangeDataWeekly = (data) => {
    var weeks = [
      { name: "MON", sent: 0, accepted: 0 },
      { name: "TUE", sent: 0, accepted: 0 },
      { name: "WED", sent: 0, accepted: 0 },
      { name: "THU", sent: 0, accepted: 0 },
      { name: "FRI", sent: 0, accepted: 0 },
      { name: "SAT", sent: 0, accepted: 0 },
      { name: "SUN", sent: 0, accepted: 0 },
    ];
    var weeksWithData = [];

    var totalRequests = 0;
    var totalAccepted = 0;
    var totalConversation = 0;
    var chatPerDay = 0;

    weeks.map((week, weekindex) => {
      var weekSentCount = 0;
      var weekAcceptedCount = 0;

      data.map((value, index) => {
        var weekDay = moment(value.thread.updateon).isoWeekday();

        if (value.thread.newrequesterstatus === "accepted") {
          if (weekDay === 0 && weekindex === 6) {
            //Sunday
            weekAcceptedCount++;
          } else if (weekDay - 1 === weekindex) {
            weekAcceptedCount++;
          }
        }

        if (weekDay === 0 && weekindex === 6) {
          //Sunday
          weekSentCount++;
        } else if (weekDay - 1 === weekindex) {
          weekSentCount++;
        }
      });

      totalRequests = totalRequests + weekSentCount;
      totalAccepted = totalAccepted + weekAcceptedCount;

      weeksWithData.push({
        ...week,
        sent: weekSentCount,
        accepted: weekAcceptedCount,
      });
    });

    data.map((value, index) => {
      totalConversation = totalConversation + value.chats.length;

      var textChats = _.filter(
        value.chats,
        (chat) => chat.chattype !== "meeting"
      );

      chatPerDay = chatPerDay + textChats.length;
    });

    this.setState({
      data: {
        graphData: weeksWithData,
        stats: {
          requests: totalRequests,
          accepted: totalAccepted,
          conversations: totalConversation,
          msgsperday: Math.ceil(chatPerDay / 7),
        },
      },
    });
  };

  arrangeDataMonthly = (data) => {
    var months = [
      { name: "JAN", sent: 0, accepted: 0 },
      { name: "FEB", sent: 0, accepted: 0 },
      { name: "MAR", sent: 0, accepted: 0 },
      { name: "APR", sent: 0, accepted: 0 },
      { name: "MAY", sent: 0, accepted: 0 },
      { name: "JUN", sent: 0, accepted: 0 },
      { name: "JUL", sent: 0, accepted: 0 },
      { name: "AUG", sent: 0, accepted: 0 },
      { name: "SEP", sent: 0, accepted: 0 },
      { name: "OCT", sent: 0, accepted: 0 },
      { name: "NOV", sent: 0, accepted: 0 },
      { name: "DEC", sent: 0, accepted: 0 },
    ];
    var monthsWithData = [];

    var totalRequests = 0;
    var totalAccepted = 0;
    var totalConversation = 0;
    var chatPerMonth = 0;

    var curYear = moment().year();
    months.map((month, monthindex) => {
      var monthSentCount = 0;
      var monthAcceptedCount = 0;

      data.map((value, index) => {
        var dateYear = moment(value.timestamp).year();
        // //If data belongs to same year
        // if (curYear === dateYear) {

        var monthDay = moment(value.thread.updateon).month();

        if (monthDay - 1 === monthindex) {
          monthSentCount++;

          if (value.thread.newrequesterstatus === "accepted") {
            monthAcceptedCount++;
          }
        }

        // }
      });

      totalRequests = totalRequests + monthSentCount;
      totalAccepted = totalAccepted + monthAcceptedCount;

      monthsWithData.push({
        ...month,
        sent: monthSentCount,
        accepted: monthAcceptedCount,
      });
    });

    data.map((value, index) => {
      var chatsThisYear = _.filter(
        value.chats,
        (chat) => moment(chat.sendon).year() === moment().year()
      );

      totalConversation = totalConversation + chatsThisYear.length;

      var textChats = _.filter(
        chatsThisYear,
        (chat) => chat.chattype !== "meeting"
      );

      chatPerMonth = chatPerMonth + textChats.length;
    });

    this.setState({
      data: {
        graphData: monthsWithData,
        stats: {
          requests: totalRequests,
          accepted: totalAccepted,
          conversations: totalConversation,
          msgsperday: Math.ceil(chatPerMonth / 12),
        },
      },
    });
  };

  arrangeDataDateWise = (data, dateObj) => {
    // console.log("data :- ", data);
    // console.log("dateObj :- ", dateObj);
    let workingDate = [];
    let selectedDate = [];
    let start = new Date(dateObj.from);
    let end = new Date(dateObj.to);
    let loop = new Date(start);
    while (loop <= end) {
      // console.log(loop);
      // console.log(moment(loop).format(DATE_FORMAT));
      workingDate.push(moment(loop).format(DATE_FORMAT));
      let month = loop.getMonth() + 1;
      selectedDate.push({
        name: loop.getDate() + "/" + month,
        sent: 0,
        accepted: 0,
      });

      let newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);
    }

    var totalRequests = 0;
    var totalAccepted = 0;
    var totalConversation = 0;
    var chatPerMonth = 0;
    var dateWithData = [];
    workingDate.map((date, index) => {
      // console.log("date :- ", date);
      var sentCount = 0;
      var acceptedCount = 0;
      var conversationCount = 0;
      var chatCount = 0;

      data.map((value, index) => {
        if (moment(value.thread.updateon).format(DATE_FORMAT) == date) {
          sentCount++;

          if (value.thread.newrequesterstatus === "accepted") {
            acceptedCount++;
          }
        }

        if (value.chats.length > 0) {
          let match = value.chats.filter((obj) => {
            return moment(obj.sendon).format(DATE_FORMAT) == date;
          });

          conversationCount = conversationCount + match.length;

          var textChats = value.chats.filter(
            (chat) =>
              moment(chat.sendon).format(DATE_FORMAT) == date &&
              chat.chattype !== "meeting"
          );

          chatCount = chatCount + textChats.length;
        }
      });

      totalRequests = totalRequests + sentCount;
      totalAccepted = totalAccepted + acceptedCount;
      totalConversation = totalConversation + conversationCount;
      chatPerMonth = chatPerMonth + chatCount;

      dateWithData.push({
        name: selectedDate[index].name,
        sent: sentCount,
        accepted: acceptedCount,
      });
    });

    // console.log("dateWithData :- ", dateWithData);
    this.setState({
      data: {
        graphData: dateWithData,
        stats: {
          requests: totalRequests,
          accepted: totalAccepted,
          conversations: totalConversation,
          msgsperday: Math.ceil(chatPerMonth / workingDate.length),
        },
      },
    });
  };

  onOptionsChange = (e) => {
    var hitstype = e.currentTarget.value;
    this.setState({ hitstype });

    if (hitstype === "weekly") {
      //Weekly
      this.arrangeDataWeekly(this.props.networkings);
    } else if (hitstype === "monthly") {
      //Monthly
      this.arrangeDataMonthly(this.props.networkings);
    } else {
      // Date wise
      this.arrangeDataDateWise(this.props.networkings, this.props.dateProps);
    }
  };

  render() {
    var { data, hitstype } = this.state;
    var statistics = data.stats;
    var graphData = data.graphData;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default dashboard-panel">
            <div
              className="panel-heading dashboard-panel-head"
              style={{ borderColor: "white" }}
            >
              <div className="pull-left text-capitalize dashboard-content-heading">
                {LocaleStrings.analytics_text_accepte_vs_total_request}
              </div>
              <div className="pull-right text-capitalize addNewField">
                <ul className="header-buttons">
                  <li>
                    <span className="analytics-chart-right-subheader">
                      {LocaleStrings.as_per_date}
                    </span>
                    {/* <select
                      onChange={this.onOptionsChange}
                      name="hitstype"
                      className="form-control"
                    >
                      <option value="weekly">{LocaleStrings.weekly}</option>
                      <option value="monthly">{LocaleStrings.monthly}</option>
                      <option value="date">{LocaleStrings.as_per_date}</option>
                    </select> */}
                  </li>
                </ul>
              </div>
            </div>
            {!_.isEmpty(graphData) ? (
              <div className="panel-body dashboard-network-graph-panel">
                <div
                  className="device-percentage"
                  style={{ paddingBottom: 50 }}
                >
                  <div className="row">
                    <div className="col-md-3">
                      <span style={{ fontSize: 24 }}>
                        {statistics.requests}
                      </span>
                      <span style={{ fontSize: 14 }}>
                        {" "}
                        {LocaleStrings.analytics_text_requests}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span style={{ fontSize: 24 }}>
                        {statistics.accepted}
                      </span>
                      <span style={{ fontSize: 14 }}>
                        {" "}
                        {LocaleStrings.analytics_text_accepted}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span style={{ fontSize: 24 }}>
                        {statistics.conversations}
                      </span>
                      <span style={{ fontSize: 14 }}>
                        {" "}
                        {LocaleStrings.analytics_text_conversations}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span style={{ fontSize: 24 }}>
                        {statistics.msgsperday}
                      </span>
                      <span style={{ fontSize: 14 }}>
                        {" "}
                        {LocaleStrings.analytics_text_message_per}{" "}
                        {hitstype === "monthly"
                          ? LocaleStrings.month
                          : LocaleStrings.day}
                      </span>
                    </div>
                  </div>
                </div>
                <LineChart
                  width={chartWidth}
                  height={220}
                  data={graphData}
                  labelLine={false}
                  legendType="circle"
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <Tooltip />
                  <Legend
                    iconSize={5}
                    wrapperStyle={{
                      top: -37,
                      left: 19,
                      height: "40px",
                      overflow: "auto",
                      width: "220px",
                      fontSize: 11,
                    }}
                    layout="vertical"
                    verticalAlign="middle"
                    align="right"
                  />
                  <Line
                    name="Requests Sent"
                    type="monotone"
                    dataKey="sent"
                    stroke="#0e6dd3"
                  />
                  <Line
                    name="Requests Accepted"
                    type="monotone"
                    dataKey="accepted"
                    stroke="#7ec857"
                  />
                </LineChart>
              </div>
            ) : (
              <div className="nouser-info">
                <span>
                  {LocaleStrings.analytics_text_no_request_recorded_yet}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    dateProps: state.analyticscommondatepropsreducer,
  };
}

export default connect(mapStateToProps, { fetchNetworkAnalytics })(
  DashboardNetworking
);
